import type { BookingWidgetFontStyle } from './types';

export function resolveBookingWidgetFontStyle(
    value?: string | null,
): BookingWidgetFontStyle {
    return value === 'serif' ? 'serif' : 'sans';
}

/** Tailwind class applied on booking widget roots (public + preview). */
export function bookingWidgetFontClassName(value?: string | null): string {
    return resolveBookingWidgetFontStyle(value) === 'serif'
        ? 'font-booking-serif'
        : 'font-booking-sans';
}
